import React, { FC } from 'react';
import { Node } from 'src/common/interfaces/node.interface';
import { DocumentInsight } from '../constants';
import { DashboardInsightsJourneysJourneyPdfViewsChart } from './pdf-views-chart';

type Props = {
  node: Node;
  documentInsights: DocumentInsight[];
};

export const DashboardInsightsJourneysJourneyDocumentInsights: FC<Props> = ({ node, documentInsights }) => {
  return (
    <div className='flex flex-col gap-4'>
      <div className='text-bedrock-black text-bedrock-p-strong'>Document Insights</div>
      <DashboardInsightsJourneysJourneyPdfViewsChart
        node={node}
        documentInsights={documentInsights}
        chartOptions={{ yLabel: 'Average time in seconds' }}
      />
    </div>
  );
};
